const React = require("react");
function IconX(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m4.04145 4 6.56355 8.8249L4 20h1.48651l5.78259-6.2819L15.9413 20H21l-6.9328-9.3213L20.215 4h-1.4865L13.403 9.78548 9.1001 4zm2.18602 1.10107h2.32396L18.8136 18.8988h-2.3239z"
  }));
}
module.exports = IconX;